function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { faCheck, faDiceSix, faKeyboard, faUser } from '@fortawesome/free-solid-svg-icons';
import { Box, HStack, Heading, Icon, Stack, useRadio, useRadioGroup, ModalBody, Divider, Button } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GiveawaySteps, GiveawayType } from '@/types/client';
import GiveawayModalHeader from './GiveawayModalHeader';
import { GiveawayModalContext } from './GiveawayModalContext';
import useGiveawayStore from '@/stores/GiveawayStore';
import { useShallow } from 'zustand/react/shallow';
function RadioCard(_param) {
    var title = _param.title, description = _param.description, icon = _param.icon, props = _object_without_properties(_param, [
        "title",
        "description",
        "icon"
    ]);
    var _useRadio = useRadio(props), getInputProps = _useRadio.getInputProps, getRadioProps = _useRadio.getRadioProps;
    var input = getInputProps();
    var checkbox = getRadioProps();
    return /*#__PURE__*/ _jsxs(Box, {
        as: "label",
        children: [
            /*#__PURE__*/ _jsx("input", _object_spread({}, input)),
            /*#__PURE__*/ _jsxs(HStack, _object_spread_props(_object_spread({}, checkbox), {
                cursor: "pointer",
                borderWidth: "1px",
                borderRadius: "md",
                borderColor: "borderSecondary",
                backgroundColor: "whiteAlpha.50",
                _checked: {
                    bg: 'primaryAlpha.300',
                    borderColor: 'primary.600'
                },
                _focus: {
                    boxShadow: 'outline'
                },
                alignItems: "center",
                spacing: 4,
                padding: 4,
                children: [
                    /*#__PURE__*/ _jsx(Icon, _object_spread_props(_object_spread({}, checkbox), {
                        as: FontAwesomeIcon,
                        icon: icon,
                        backgroundColor: "borderSecondary",
                        _checked: {
                            backgroundColor: 'primaryAlpha.300'
                        },
                        padding: 3,
                        borderRadius: "md"
                    })),
                    /*#__PURE__*/ _jsxs(Stack, {
                        spacing: 0,
                        flex: 1,
                        children: [
                            /*#__PURE__*/ _jsx(Heading, {
                                size: "sm",
                                children: title
                            }),
                            /*#__PURE__*/ _jsx(Box, {
                                fontSize: "sm",
                                color: "textSecondary",
                                children: description
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Icon, _object_spread_props(_object_spread({}, checkbox), {
                        as: FontAwesomeIcon,
                        icon: faCheck,
                        color: "primary.600",
                        _checked: {
                            display: 'block'
                        },
                        display: "none"
                    }))
                ]
            }))
        ]
    });
}
function GiveawayTypeStep() {
    var intl = useIntl();
    var _React_useContext = React.useContext(GiveawayModalContext), onClose = _React_useContext.onClose, setStep = _React_useContext.setStep;
    var _useGiveawayStore = useGiveawayStore(useShallow(function(state) {
        return {
            type: state.type,
            setType: state.setType
        };
    })), setType = _useGiveawayStore.setType, type = _useGiveawayStore.type;
    var _useRadioGroup = useRadioGroup({
        name: 'giveawayType',
        defaultValue: type !== null && type !== void 0 ? type : GiveawayType.ACTIVE_USER,
        onChange: function(value) {
            return setType(value);
        }
    }), getRootProps = _useRadioGroup.getRootProps, getRadioProps = _useRadioGroup.getRadioProps;
    return /*#__PURE__*/ _jsxs(ModalBody, {
        padding: 0,
        children: [
            /*#__PURE__*/ _jsx(GiveawayModalHeader, {
                title: intl.formatMessage({
                    id: "oTAAbB",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Select Giveaway Type"
                        }
                    ]
                }),
                onClose: onClose
            }),
            /*#__PURE__*/ _jsx(Divider, {
                borderColor: "borderSecondary"
            }),
            /*#__PURE__*/ _jsxs(Stack, _object_spread_props(_object_spread({
                padding: 6,
                spacing: 6
            }, getRootProps()), {
                children: [
                    /*#__PURE__*/ _jsx(RadioCard, _object_spread_props(_object_spread({}, getRadioProps({
                        value: GiveawayType.ACTIVE_USER
                    })), {
                        title: intl.formatMessage({
                            id: "hD43nJ",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Giveaway"
                                }
                            ]
                        }),
                        description: intl.formatMessage({
                            id: "o/EyVa",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Users enter by being active in chat."
                                }
                            ]
                        }),
                        icon: faUser
                    })),
                    /*#__PURE__*/ _jsx(RadioCard, _object_spread_props(_object_spread({}, getRadioProps({
                        value: GiveawayType.KEYWORD
                    })), {
                        title: intl.formatMessage({
                            id: "0gvdUD",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Keyword Giveaway"
                                }
                            ]
                        }),
                        description: intl.formatMessage({
                            id: "RVFtUQ",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Users type a phrase to enter the giveaway."
                                }
                            ]
                        }),
                        icon: faKeyboard
                    })),
                    /*#__PURE__*/ _jsx(RadioCard, _object_spread_props(_object_spread({}, getRadioProps({
                        value: GiveawayType.RANDOM_NUMBER
                    })), {
                        title: intl.formatMessage({
                            id: "FXn2yf",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Random Number"
                                }
                            ]
                        }),
                        description: intl.formatMessage({
                            id: "L/igIj",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Users win by guessing a random number."
                                }
                            ]
                        }),
                        icon: faDiceSix
                    }))
                ]
            })),
            /*#__PURE__*/ _jsx(Divider, {
                borderColor: "borderSecondary"
            }),
            /*#__PURE__*/ _jsxs(HStack, {
                spacing: 6,
                p: 6,
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        onClick: onClose,
                        flex: 1,
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "47FYwb",
                            defaultMessage: "Cancel"
                        })
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        flex: 1,
                        variant: "cta",
                        onClick: function() {
                            return setStep(GiveawaySteps.ELIGIBILITY);
                        },
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "9+Ddtu",
                            defaultMessage: "Next"
                        })
                    })
                ]
            })
        ]
    });
}
export default GiveawayTypeStep;
